import { NgClass } from '@angular/common';
import { Component, input } from '@angular/core';

@Component({
  selector: 'ui-stepper-step',
  imports: [NgClass],
  templateUrl: './stepper-step.html',
  host: {
    class: 'contents',
  },
})
export class StepperStep {
  status = input.required<'UPCOMING' | 'CURRENT' | 'COMPLETED'>();
}
